/**
 * Untamed Theme - Offline License Validation
 * Validates lifetime JWT licenses without network calls
 * ============================================
 */

(function() {
  'use strict';

  var CONFIG = {
    DEBUG: false
  };

  function log() {
    if (CONFIG.DEBUG && typeof console !== 'undefined') {
      try { 
        console.log.apply(console, ['[Untamed License]'].concat([].slice.call(arguments))); 
      } catch (_) {}
    }
  }

  /**
   * Decode base64url string to JSON object
   */
  function base64UrlDecode(str) {
    try {
      // Convert base64url to base64
      var base64 = str.replace(/-/g, '+').replace(/_/g, '/');
      // Add padding if needed
      while (base64.length % 4) {
        base64 += '=';
      }
      return JSON.parse(atob(base64));
    } catch (_) { 
      return null; 
    }
  }

  /**
   * Verify a lifetime license key (offline, no signature verification)
   * @param {string} licenseKey - JWT-style license key
   * @returns {object} { valid: boolean, reason?: string, payload?: object }
   */
  function verifyLifetimeLicense(licenseKey) {
    try {
      // Check if license key exists
      if (!licenseKey || typeof licenseKey !== 'string') {
        return { valid: false, reason: 'missing' };
      }

      // JWT format: header.payload.signature
      var parts = licenseKey.split('.');
      if (parts.length !== 3) {
        return { valid: false, reason: 'format' };
      }

      // Decode header and payload (we don't verify signature offline)
      var header = base64UrlDecode(parts[0]);
      var payload = base64UrlDecode(parts[1]);

      if (!header || !payload) {
        return { valid: false, reason: 'decode' };
      }

      // Check header type
      if (header.typ !== 'UNTMD') {
        return { valid: false, reason: 'type_header' };
      }

      // Offline validation: require type === 'lifetime'
      if (payload.type !== 'lifetime') {
        return { valid: false, reason: 'not_lifetime' };
      }

      // Check product
      if (payload.product !== 'untamed-theme') {
        return { valid: false, reason: 'wrong_product' };
      }

      // Check expiration (should be null for lifetime, but handle edge cases)
      if (typeof payload.exp === 'number' && Math.floor(Date.now() / 1000) > payload.exp) {
        return { valid: false, reason: 'expired' };
      }

      log('License validated:', payload);
      return { valid: true, payload: payload };

    } catch (e) {
      log('License validation error:', e);
      return { valid: false, reason: 'error' };
    }
  }

  /**
   * Show license error overlay
   */
  function showOverlay(title, message) {
    try {
      // Remove any existing overlay
      var existing = document.getElementById('untamed-license-overlay');
      if (existing) existing.remove();

      var overlay = document.createElement('div');
      overlay.id = 'untamed-license-overlay';
      overlay.setAttribute('style', [
        'position: fixed',
        'inset: 0',
        'background: rgba(255, 255, 255, 0.98)',
        'z-index: 2147483647',
        'display: flex',
        'align-items: center',
        'justify-content: center',
        'font-family: -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, Arial, sans-serif'
      ].join(';'));

      overlay.innerHTML = [
        '<div style="text-align:center;padding:40px;max-width:560px">',
        '<div style="font-size:48px;color:#ff4444;margin-bottom:16px">⚠️</div>',
        '<h2 style="margin:0 0 12px 0;color:#333;font-size:24px;font-weight:600">' + (title || 'License Required') + '</h2>',
        '<p style="margin:0 0 20px 0;color:#666;font-size:16px;line-height:1.5">' + (message || 'Please configure your Untamed theme license key in theme settings.') + '</p>',
        '<p style="margin:0;color:#999;font-size:14px">',
        'Go to <strong>Online Store → Themes → Customize → Theme Settings → License Configuration</strong>',
        '</p>',
        '<p style="margin:16px 0 0 0;color:#999;font-size:13px">',
        'Need help? Contact <a href="mailto:support@buyuntamed.com" style="color:#165DFF">support@buyuntamed.com</a>',
        '</p>',
        '</div>'
      ].join('');

      document.body.appendChild(overlay);
      document.body.style.overflow = 'hidden';
    } catch (_) {}
  }

  /**
   * Enable the theme (license valid)
   */
  function enableTheme() {
    log('Theme enabled - valid license');
    // Theme is enabled by default, nothing to do
  }

  /**
   * Show overlay when DOM is ready
   */
  function showOverlayWhenReady(title, message) {
    if (document.body) {
      showOverlay(title, message);
    } else {
      document.addEventListener('DOMContentLoaded', function() {
        showOverlay(title, message);
      });
    }
  }

  /**
   * Initialize license validation
   */
  function init() {
    // Wait for settings to be available
    if (!window.UntamedThemeSettings) {
      setTimeout(init, 100);
      return;
    }

    var key = window.UntamedThemeSettings.licenseKey;

    // Check if license key is configured
    if (!key || String(key).trim() === '') {
      log('No license key configured');
      showOverlayWhenReady('Theme License Required', 'Please enter your Untamed theme license key to activate the theme.');
      return;
    }

    // Validate the license
    var result = verifyLifetimeLicense(String(key).trim());

    if (!result.valid) {
      log('License validation failed:', result.reason);
      
      var errorMessages = {
        'missing': 'License key is missing.',
        'format': 'Invalid license key format.',
        'decode': 'Unable to decode license key.',
        'type_header': 'Invalid license type.',
        'not_lifetime': 'This theme requires a lifetime license.',
        'wrong_product': 'License is not valid for this product.',
        'expired': 'License has expired.',
        'error': 'Error validating license.'
      };

      var message = errorMessages[result.reason] || 'Invalid license key.';
      showOverlayWhenReady('Invalid License', message + ' Please check your license key and try again.');
      return;
    }

    // License is valid
    enableTheme();
  }

  // Start initialization immediately - settings should already be defined inline before this script
  init();

})();

